export default "__VITE_ASSET__19255c3b__"